import styles from './banner.module.scss'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Banner1 from '/public/images/gb.png'
import icon from '/public/images/ans.png'
import { useRouter } from 'next/router'
import { useWidth } from '@/utils/resize'
import buriedSdk from '@/utils/zz-buried/index'

type Props = {}
const Index = (props: Props) => {
  const { width, display } = useWidth()
  const { t, i18n } = useTranslation('home')
  console.log(i18n)
  const router = useRouter()
  const { locales, locale: activeLocale } = router
  const clickAbled = (text, link) => {
    buriedSdk.buried({
      event: `按钮点击`,
      scene: `${text}`,
      URL: window.location.href
    })
    window.open(
      link,
      '_blank'
    )
  }
  return (
    <div
      className={`${styles.main} ${styles['main_b1']}`}
      style={{
        background: 'linear-gradient(90deg, #D9FCFF, #FFD2E4);'
      }}
    >
      <div className={`defeaultContainer ${styles.top}`}>
        <div className={`flex items-center ${styles.topwrap} lg1024:pt-[40px]`}>
          <div className={`${styles.left2} animate-box lg1024:pl-[20px] lg1024:pr-[20px]`}>
            <div className={styles.imgs}>
            <Image
                layout="responsive"
                alt="TikTok e-commerce product trends"
                src={icon}
              ></Image>
            </div>
            <div className={ `${styles.title1} ${styles['b1_title']}`}>
             
              {t('helpUse')}
            </div>
            <ul className={ `${styles.title2} ${styles.dieMain}`} >
              <li> {t('helpUse1-1')}<b> {t('helpUse1-2')}</b> {t('helpUse1-3')}</li>
              <li> {t('helpUse2-1')}<b> {t('helpUse2-2')}</b>{t('helpUse2-3')}</li>
              <li> {t('helpUse3-1')}<b> {t('helpUse3-2')}</b> {t('helpUse3-3')} <b> {t('helpUse3-4')}</b> {t('helpUse3-5')}</li>
            </ul>
            <ul className={ `${styles.title2} ${styles.die}`} >
              <li> {t('help-m-1')}</li>
              <li> {t('help-m-2')}</li>
              <li> {t('help-m-3')}</li>
            </ul>
   
            <div
              className={`${styles.btn} ${styles['btn_b1']}`}
              onClick={() => {
                clickAbled('文章详情页-banner-Start Free Trial按钮',width > 1024 ? process.env.portalUrl + '/home' : process.env.mobileUrl)
              }}
            >
              {t('GET STARTED')}
            </div>
          </div>
          <div className={`${styles.right2} animate-box`}>
            <div className={`${styles.pic}  lg1024:hidden`}>
              <Image
                layout="responsive"
                alt="TikTok e-commerce product trends"
                src={Banner1}
              ></Image>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Index
